<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='规范管理' url='/standard/standardlist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <ZPGLSearchDictItemSelect v-model='condition.spid' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <ZPGLSearchDictItemSelect v-model='condition.standardyear' label='届别' :dictid='this.$utils.DictEnum.stuyear'></ZPGLSearchDictItemSelect>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/standard/standardadd" buttonname="新增规范信息"></AddButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="SpName" label="专业">
            </el-table-column>
            <el-table-column prop="StandardYearName" label="届别">
            </el-table-column>
            <el-table-column prop="StandardName" label="规范名称">
            </el-table-column>
            <el-table-column prop="StandardRemark" label="规范说明">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="Info(scope.row)" type="text" size="medium">详细</el-button>
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StandardList',
    data() {
      return {
        condition: {
          spid: '',
          standardyear: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIStandard/List',
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'StandardEdit',
          params: {
            id: row.StandardID
          }
        })
      },
      Info: function(row) {
        this.$router.push({
          name: 'StandardInfo',
          params: {
            id: row.StandardID
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.StandardID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APIStandard/Delete', args, row.StandardName, this.$refs.btnSearch.Search)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
